import { gql } from '@apollo/client';

import { TARGETING_RULE_DEFINITION } from '../../../../apis/graphql';
import { ADS_PAGE_AD } from '../../../../common/AdForm/hooks/fragments';

// Data for Create Ads Page
export const GET_SAVED_ADS = gql`
  query getSavedAds($lineItemIds: [ID!]!, $lineItemId: String!, $selectedAdIds: [ID!]) {
    lineItems: lineItemsV5(filterOptions: { idList: $lineItemIds, skipCPEligibilityCalculation: true }) {
      edges {
        node {
          schedule {
            timezone
            dateRangeList {
              startDate
              endDate
              pacingShare
            }
          }
          targetingRule {
            ...targetingRuleDefinition
          }
          isCoppaOrCaru
          startDate
          endDate
          displayPublisherTarget
          metrics {
            completions
          }
          metadata {
            actualStartDate
          }
          deal {
            __typename
          }
          campaign {
            name
            id
            campaignTagList {
              id
              type
              url
            }
            startDate
          }
          adProduct
          billableEvent
        }
      }
    }
    ads: adsV5(
      filterOptions: { lineItemIdList: $lineItemIds, selectedIdList: $selectedAdIds }
      paginationOptions: { limit: 1000 }
    ) {
      edges {
        node {
          ...adsPageAd
        }
      }
    }
    getTargetingTermValuesByLineItemIDV5(lineItemId: $lineItemId) {
      category {
        id
        name
        displayName
      }
      dimension {
        id
        name
        displayName
      }
      value {
        id
        name
        displayName
      }
      include
    }
  }
  ${ADS_PAGE_AD}
  ${TARGETING_RULE_DEFINITION}
`;
